var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-10 w-full h-full flex-1 flex flex-col"},[_c('div',{staticClass:"flex w-full flex-1"},[_c('TimetableSplitViewEventList'),_c('TimetableSplitViewTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }